var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/GenericFilterSort/OfferingsCheckboxListFilters/OfferingsCheckboxListFilters.scss";
import SearchBar from "@frameworks/web/components/generic/SearchBar";
import { Accordion, Spinner } from "react-bootstrap";
import BasicErrorMessage from "@frameworks/shared-library/components/BasicErrorMessage/BasicErrorMessage";
export var ETypeOfCheckboxFilter;
(function (ETypeOfCheckboxFilter) {
    ETypeOfCheckboxFilter["PARENT_FILTER"] = "PARENT_FILTER";
    ETypeOfCheckboxFilter["CHILD_FILTER"] = "CHILD_FILTER";
})(ETypeOfCheckboxFilter || (ETypeOfCheckboxFilter = {}));
var OfferingsCheckboxListFilters = function (props) {
    var _a;
    var _b = __read(React.useState(""), 2), searchedValue = _b[0], setSearchedValue = _b[1];
    var _c = __read(React.useState([]), 2), localFiltersList = _c[0], setLocalFiltersList = _c[1];
    var generateUIComponent = function (data) {
        var _a, _b;
        if (!!(data === null || data === void 0 ? void 0 : data.subList) && data.subList.length) {
            return (React.createElement(Accordion, { defaultActiveKey: (data === null || data === void 0 ? void 0 : data.isAccordionOpenByDefault) ? (_a = data.value) === null || _a === void 0 ? void 0 : _a.toString() : undefined },
                React.createElement(Accordion.Item, { eventKey: (_b = data.value) === null || _b === void 0 ? void 0 : _b.toString() },
                    React.createElement(Accordion.Header, { onClick: function (e) {
                            e.stopPropagation();
                        } }, generateCheckbox(data, ETypeOfCheckboxFilter.PARENT_FILTER)),
                    React.createElement(Accordion.Body, null,
                        React.createElement("div", { className: "nested-child-filter" }, data.subList.map(function (nestedFilter) {
                            return generateCheckbox(nestedFilter, ETypeOfCheckboxFilter.CHILD_FILTER);
                        }))))));
        }
        else {
            return generateCheckbox(data, ETypeOfCheckboxFilter.PARENT_FILTER);
        }
    };
    var generateCheckbox = function (data, typeOfFilter) {
        var _a, _b;
        return (React.createElement(GenericCheckbox, { key: data.value, parentClassName: "individual-checkbox-wrapper", checkboxProps: {
                onChange: function (e) { return handleChooseOnChangeHandler(typeOfFilter, e, data); },
                onClick: function (e) { return e.stopPropagation(); },
                id: (_a = data === null || data === void 0 ? void 0 : data.value) === null || _a === void 0 ? void 0 : _a.toString(),
                // checked: props?.selectedValuesList?.includes(data.id ?? data.name),
                checked: handleCheckIfCheckboxIsChecked(typeOfFilter, data),
                value: data.value,
                ref: function (e) {
                    var _a, _b;
                    if (!!e) {
                        e.indeterminate =
                            // e.checked &&
                            // FIXME: Below conditions are not working
                            typeOfFilter === ETypeOfCheckboxFilter.PARENT_FILTER
                                ? handleCheckIfPropertyExistInObject(props.selectedValuesList, props.parentKeyName) &&
                                    handleCheckIfPropertyExistInObject(props.selectedValuesList[props.parentKeyName], data.parentFilterValue) &&
                                    Object.keys((_a = props.selectedValuesList[props.parentKeyName][data.parentFilterValue]) === null || _a === void 0 ? void 0 : _a.subListFiltersValues).length < ((_b = data === null || data === void 0 ? void 0 : data.subList) === null || _b === void 0 ? void 0 : _b.length)
                                : false;
                    }
                },
            }, labelProps: {
                htmlFor: (_b = data === null || data === void 0 ? void 0 : data.value) === null || _b === void 0 ? void 0 : _b.toString(),
                children: data.label,
            }, checkboxType: "han-blue" }));
    };
    var generateError = function () {
        if (!!searchedValue) {
            return (React.createElement(BasicErrorMessage, { primaryText: "No results found!", subText: "Try searching for something else or explore other options." }));
        }
        else {
            return (React.createElement(BasicErrorMessage, { primaryText: "No results found!", subText: "Try reloading the page or try after sometime." }));
        }
    };
    var handleChooseOnChangeHandler = function (typeOfFilter, e, data) {
        switch (typeOfFilter) {
            case ETypeOfCheckboxFilter.PARENT_FILTER:
                handleParentCheckboxChange(e, data);
                break;
            case ETypeOfCheckboxFilter.CHILD_FILTER:
                handleChildCheckboxChange(e, data);
                break;
            default:
                (function () { });
                break;
        }
    };
    var handleParentCheckboxChange = function (e, data) {
        var _a;
        e.stopPropagation();
        var localSelectedData = __assign({}, props.selectedValuesList);
        var parentKey = props.parentKeyName;
        var targetValue = e.target.value;
        if ((_a = data === null || data === void 0 ? void 0 : data.subList) === null || _a === void 0 ? void 0 : _a.length) {
            var subListFiltersValues = data.subList.reduce(function (acc, currValue) {
                acc[currValue.value] = { filterValue: currValue.value };
                return acc;
            }, {});
            if (!localSelectedData[parentKey]) {
                localSelectedData[parentKey] = {};
            }
            addOrRemoveFilterValue(localSelectedData[parentKey], targetValue, targetValue, data.label, subListFiltersValues);
        }
        else {
            if (!localSelectedData[parentKey]) {
                localSelectedData[parentKey] = {};
            }
            addOrRemoveFilterValue(localSelectedData[parentKey], targetValue, targetValue, data.label);
        }
        if (props === null || props === void 0 ? void 0 : props.onChangeCallback) {
            props.onChangeCallback(localSelectedData);
        }
    };
    var handleChildCheckboxChange = function (e, data) {
        var localSelectedData = __assign({}, props.selectedValuesList);
        var parentKey = props.parentKeyName;
        var parentFilterValue = data.parentFilterValue;
        var targetValue = e.target.value;
        if (!localSelectedData[parentKey]) {
            localSelectedData[parentKey] = {};
        }
        var parentSelectedData = localSelectedData[parentKey];
        if (!parentSelectedData[parentFilterValue]) {
            parentSelectedData[parentFilterValue] = {
                filterValue: parentFilterValue,
                subListFiltersValues: {},
                displayValue: data === null || data === void 0 ? void 0 : data.parentFilterLabel,
            };
        }
        var subListFilters = parentSelectedData[parentFilterValue].subListFiltersValues || {};
        addOrRemoveSubListFilter(subListFilters, targetValue);
        if (!Object.keys(subListFilters).length) {
            delete parentSelectedData[parentFilterValue];
        }
        if (props === null || props === void 0 ? void 0 : props.onChangeCallback) {
            props.onChangeCallback(localSelectedData);
        }
    };
    var addOrRemoveFilterValue = function (targetObj, key, filterValue, displayValue, subListFiltersValues) {
        if (handleCheckIfPropertyExistInObject(targetObj, key)) {
            delete targetObj[key];
        }
        else {
            targetObj[key] = { filterValue: filterValue, subListFiltersValues: subListFiltersValues, displayValue: displayValue };
        }
    };
    var addOrRemoveSubListFilter = function (subListFilters, value) {
        if (handleCheckIfPropertyExistInObject(subListFilters, value)) {
            delete subListFilters[value];
        }
        else {
            subListFilters[value] = { filterValue: value };
        }
    };
    var handleCheckIfPropertyExistInObject = function (object, key) {
        return object === null || object === void 0 ? void 0 : object.hasOwnProperty(key);
    };
    var handleCheckIfCheckboxIsChecked = function (typeOfFilter, data) {
        var _a;
        switch (typeOfFilter) {
            case ETypeOfCheckboxFilter.PARENT_FILTER:
                if (handleCheckIfPropertyExistInObject(props.selectedValuesList, props.parentKeyName)) {
                    return props.selectedValuesList[props.parentKeyName].hasOwnProperty(data.value);
                }
                else {
                    return false;
                }
            case ETypeOfCheckboxFilter.CHILD_FILTER:
                if (handleCheckIfPropertyExistInObject(props.selectedValuesList, props.parentKeyName)) {
                    if (handleCheckIfPropertyExistInObject(props.selectedValuesList[props.parentKeyName], data === null || data === void 0 ? void 0 : data.parentFilterValue)) {
                        return handleCheckIfPropertyExistInObject((_a = props.selectedValuesList[props.parentKeyName][data.parentFilterValue]) === null || _a === void 0 ? void 0 : _a.subListFiltersValues, data.value);
                    }
                }
                else {
                    return false;
                }
            default:
                return false;
        }
    };
    var handleSearchChange = function (e) {
        var searchedFilters = __spreadArray([], __read(props.displayDataList), false);
        if (e === null || e === void 0 ? void 0 : e.length) {
            searchedFilters = searchedFilters.filter(function (item) { var _a, _b; 
            // hasRequiredProperties(item) &&
            return (_b = (_a = item.searchKey) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(e === null || e === void 0 ? void 0 : e.toLowerCase()); });
        }
        setSearchedValue(e);
        setLocalFiltersList(searchedFilters);
        (props === null || props === void 0 ? void 0 : props.onSearchChangeCallback) &&
            props.onSearchChangeCallback(searchedValue, props.displayDataList, props.selectedValuesList);
    };
    var handleCustomSearchFunctionality = function (e) {
        props.customSearchFunction(e, props.displayDataList, props.selectedValuesList);
    };
    React.useEffect(function () {
        if (!!props.displayDataList)
            setLocalFiltersList(props.displayDataList);
    }, [props.displayDataList]);
    React.useEffect(function () {
        return function () {
            setSearchedValue("");
        };
    }, []);
    return (React.createElement("div", { className: "primary-offerings-checkbox-list-filters-container h-100 d-flex flex-column ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "") }, (props === null || props === void 0 ? void 0 : props.loader) ? (React.createElement("div", { className: "d-flex align-items-center justify-content-center h-100" },
        React.createElement(Spinner, { animation: "border", variant: "primary" }))) : (React.createElement(React.Fragment, null,
        props.enableSearch ? (React.createElement(SearchBar, { iconColors: "txt_dull-grey", openInputBackground: "", autoComplete: "off", searchBarBackground: "bg_white", onCallbackFunction: function (e) {
                return !!(props === null || props === void 0 ? void 0 : props.customSearchFunction)
                    ? handleCustomSearchFunctionality(e)
                    : handleSearchChange(e);
            }, deskPlaceHolder: props === null || props === void 0 ? void 0 : props.searchInputPlaceholder, parentClassName: "search-bar-wrapper-for-filters padding-15" })) : (React.createElement(React.Fragment, null)),
        localFiltersList.length
            ? localFiltersList.map(function (item, index) {
                return generateUIComponent(item);
            })
            : generateError()))));
};
export default OfferingsCheckboxListFilters;
